module.exports = __webpack_public_path__ + "static/homo-deus-c1bd341574534ff9e21fe7956b418940.jpg";